<template>
  <div class="box">
    <settings-form />
  </div>
</template>

<script>
import SettingsForm from '@/components/SettingsForm'

export default {
  name: 'Settings',
  components: { SettingsForm },
  metaInfo () {
    return { title: this.$t('title') }
  }
}
</script>

<i18n>
{
  "en-US": {
    "title": "Settings"
  },
  "pt-BR": {
    "title": "Configurações"
  }
}
</i18n>
